<template>
    <div class="home" v-loading="loading"  element-loading-text="游戏准备中，请稍候">
        <div class="main-content" data-v-2ec16703=""><!---->
            <video v-if="!clientRuning" :src="bg" muted="muted"
                   autoplay="autoplay" loop="loop" class="bg"></video>
            <div class="top-container">
            </div>
            <GameInfo :supportInstall="supportInstall" :limitTime="limitTime" :share_link="share_link" :wdId="wd_id" :account="account" :token="token" v-show="clientRuning" @buyTime="buyTime" @submitSave="submitSave" @copy="copy" @exitGame="exitGame"
                      class="home-header">
                <div class="game-box">
                    <div class="game-info-item">
                        <div class="game-label">延时：</div>
                        <div class="game-value" :class="netWorkDelay >= 80 ? 'color-red' : ''">{{netWorkDelay}}MS</div>
                    </div>
                    <div class="game-info-item">
                        <div class="game-label">丢包率：</div>
                        <div class="game-value" :class="packetLossRate >= 1 ? 'color-red' : ''">{{parseInt(packetLossRate * 100)}}%</div>
                    </div>
                    <div class="game-info-item">
                        <div class="game-label">FPS：</div>
                        <div class="game-value" :class="fps < 30 ? 'color-red' : ''">{{fps}}</div>
                    </div>
                    <div class="game-info-item">
                        <div class="game-label">码率：</div>
                        <div class="game-value">{{bitrate}}</div>
                    </div>
                </div>
            </GameInfo>
<!--            首页-->
            <div class="home-info" v-if="process==1">
                <div class="home-left">
                    <img v-if="desc" :src="desc" alt="">
                </div>
                <div class="home-right">
                    <HomeRight :tip="tip" :channel_id="channel_id" :lunbo="lunbo" :supportInstall="supportInstall" :limitTime="limitTime" :downloadUrl="downloadUrl" ref='myLogin' :account="account" :token="token" @buyTime="buyTime" @startGame="startGame" @login="login" v-show="!clientRuning" @submitSave="submitSave" @signOut="signOut" @log="setClientLog"></HomeRight>
                </div>
            </div>
<!--            游戏页-->
            <div v-show="process==3" id="cgameLayer"></div>
<!--            排队页面-->
            <queue v-show="process==4" :holdTime="holdTime" :person="person" @cancelQueue="cancelQueue"></queue>
<!--            支付页-->
            <rechargeDialog v-if="showRecharge" :left_exp_time="left_exp_time" :downloadUrl="downloadUrl" :anti_level="anti_level" :forbid_game="forbid_game" @close="closeRechargeDialog" @emitGetAccount="emitGetAccount" @rechargeSuccess="rechargeSuccess"></rechargeDialog>
<!--            充值页-->
            <rechargeNow @buyTime="buyTime" :limitTime="limitTime" v-if="process==2" @signOut="signOut"></rechargeNow>
            <pop-up :showClose="false" width="500" height="350" title="实名认证" v-if="showAnti">
                <div class="anti-main">
                    <div class="anti-input-box">
                        <el-input v-model="commonRule.name" placeholder="请输入真实姓名"></el-input>
                        <el-input v-model="commonRule.id_card" placeholder="请输入身份证号码"></el-input>
                    </div>
                    <div v-if="antiReasonShow" class="refuse-result">实名认证未通过</div>
                </div>
                <template v-slot:footer>
                    <div class="anti-footer">
                        <div class="cancel-btn" @click="cancelAnti">取消</div>
                        <div @click="sureAnti">确认</div>
                    </div>
                </template>
            </pop-up>
            <!--            </div>-->
            <media v-if="!clientRuning" :medias="third" :wdId="wd_id" :account="account"></media>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import Header from '@/components/Header.vue'
import HomeRight from '@/components/HomeRight.vue'
import api from '@/utils/api'
import GameInfo from '@/components/GameInfo.vue'
import rechargeNow from '@/components/rechargeNow.vue'
import queue from '@/components/queue.vue'
import rechargeDialog from '@/components/rechargeDialog.vue'
import { mapMutations } from 'vuex'
import popUp from '@/components/popUp.vue'
import {
    DEFAULT_DOWNLOAD_4399_URL,
    DEFAULT_DOWNLOAD_URL,
    getUniqueBrowserId,
    isIdCard,
    secondsToTime
} from '@/utils/util'
import { Loading } from 'element-ui'
import media from '@/components/media.vue'

let timer = null // 实名认证loading
let interval = null // ApiToken刷新定时器
let accountInterval = null // 账户余额刷新定时器
let timeLimit = null // 倒计时计时器

const cgSDK = window.CGSDK
const { MsgInput } = window.CGSDKE;
const acgCoreManager = cgSDK.getCoreManager()
const acgInteractManager = cgSDK.getInteractManager()
const { resizeStage } = window.CGSDKE
let msgInput = null;
let sdkIniting = false
let sdkInited = false
let $container = {}
let gameSession = ''
let deferredPrompt;

export default {
    name: 'HomeView',
    components: {
        GameInfo,
        media,
        rechargeNow,
        queue,
        popUp,
        rechargeDialog,
        HomeRight,
    },
    computed: {
        process () {
            return this.$store.state.process
        },
        is4399 () {
            return this.$store.state.is4399
        },
    },
    data () {
        return {
            secondsToTime,
            downloadUrl: '',
            isLX: false,
            from: 'website',
            apiToken: '', // 临时token
            appKey: '',
            appSecret: '',
            type_0: '', // id为0的状态, 第一次退出登录的标记
            type_1: '', // id为1的状态，第一次弹出访问官网的标记
            type_2: '', // id为2的状态，第一次点击gameInfo里退出游戏的弹窗标记
            token: '', // web Token
            clientToken: '', // 客户端token
            channel_ad_id: '', // 用户广告id
            sub_channel_id: 4228, // 用户子渠道id
            channel_id: 1,
            anti_level: 0, // 实名认证状态 0 未实名 1实名成年 2实名未成年
            forbid_game: 1, // 0 不禁止进入游戏 1未成年禁止进入游戏
            is_test_account: false, // 账号白名单 false 非白名单成员  true 白名单成员
            server_status: false, // 服务器状态 false 未开服 true 开服
            real_name_url: '', // 4399实名认证连接
            showRecharge: false,
            clientRuning: false, // 游戏是否启动中
            loading: false, // 加载状态
            readyToStart: false,
            showAnti: false, // 显示实名认证弹窗
            antiReasonShow: false, // 实名认证结果是否展示
            wd_id: 0,
            share_link: '',  // 分享链接
            mixGameId: '',
            is_audit: '',
            commonRule: {
                name: '',
                id_card: '',
            },
            supportInstall: false, // 浏览器是否支持
            netWorkDelay: 0,
            fps: 0,
            bitrate: 0,
            packetLossRate: 0,
            account: '',
            expire_time: '', // 月卡到期时间（时间戳，单位秒）
            ttl: '', // 月卡剩余时长（为0代表月卡已失效）
            left_time: '', // 剩余标准时长（单位：秒）
            left_exp_time: '', // 剩余体验时长（单位：秒）
            limitTime: 0, // 剩余总体时长（单位：秒）
            holdTime: 0, // 排队剩余时间
            user_level: 0, // 级别
            person: 0, // 排队人数
            third: [], // 右侧icon
            lunbo: [], // 右上角图片轮播
            tip: '',
            bg: '',
            desc: '',
        }
    },
    async created () {
        const _this = this;
        this.setIs4399(this.$route.query.from === '4399web_2457700002')
        await this.queryDownload();
        // 仅浏览器支持且未安装该应用，以下事件才会触发
        window.addEventListener('beforeinstallprompt', (e) => {
            // Chrome 67 及之前版本，会自动展现安装的 prompt
            // 为了版本统一及用户体验，我们禁止自动展现 prompt
            e.preventDefault();
            // 存放事件用于后续触发
            deferredPrompt = e;
            console.log(deferredPrompt, '--deferredPrompt1---')
            // 展现按钮
            _this.supportInstall = true;
            console.log('您的浏览器支持保存到桌面');
        });
    },
    async mounted () {
        const _this = this;
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register(window.location.origin + '/sw.js')
                .then(registration => {
                    console.log('Service Worker 注册成功：', registration);
                })
                .catch(error => {
                    console.log('Service Worker 注册失败：', error);
                });
        }
        const mixGameIdMap = {
            develop: 'cgeabnumicwwyy',
            pre: 'cgeabnvaedvrne',
            master: 'cgeabnumrzwtec',
        };
        console.log(process.env.VUE_APP_ENV, '--process.env.VUE_APP_ENV--')
        if (!mixGameIdMap[process.env.VUE_APP_ENV]) {
            console.error('请检查分支')
            this.$message.error('请检查分支');
        }
        this.mixGameId = mixGameIdMap[process.env.VUE_APP_ENV] ? mixGameIdMap[process.env.VUE_APP_ENV] : mixGameIdMap.pre
        this.setClientLog(8)
        this.queryAd();
        $container = document.querySelector('#cgameLayer')
        const msgInputLeftRate = 0.15;
        const msgInputTopRate = 0.95;
        msgInput = new MsgInput(cgSDK, $container, { leftRate: msgInputLeftRate, topRate: msgInputTopRate });

        if (this.$route.query.token) {
            api.setAuthToken(this.$route.query.token)

            const newQuery = JSON.parse(JSON.stringify(this.$route.query));
            delete newQuery.token;
            if (newQuery.userData) {
                delete newQuery.userData;
                delete newQuery.expire;
            }
            this.$router.replace({ query: newQuery });
        }
        if (api.getAuthToken()) {
            this.token = api.getAuthToken();
            this.queryClientInfo('login')
        }
    },
    beforeDestroy () {
        clearInterval(timeLimit)
        timeLimit = null;
        clearInterval(interval)
        interval = null;
        clearInterval(accountInterval)
        accountInterval = null;
        // 关闭页面时停止游戏
        this.gameStop()
    },
    methods: {
        ...mapMutations(['setShowLogin', 'setProcess', 'setIs4399', 'setMissionCompleteStatus']),
        async queryDownload () {
            const { from } = this.$route.query;
            if (this.is4399) {
                this.downloadUrl = DEFAULT_DOWNLOAD_4399_URL;
                this.sub_channel_id = 24577;
                this.channel_id = 6;
            } else {
                if (from) {
                    this.from = from;
                    await this.$api.get('/v1/config', { from: this.from }).then((res) => {
                        this.downloadUrl = res.game_download_url || DEFAULT_DOWNLOAD_URL;
                        this.sub_channel_id = res.sub_channel_id || 4228;
                        this.channel_id = res.channel_id || 1;
                    }).catch((e) => {
                        this.$message.error(e.message);
                    })
                } else {
                    this.downloadUrl = DEFAULT_DOWNLOAD_URL
                }
            }
            console.log(this.downloadUrl, '---下载地址： ' + this.downloadUrl)
        },
        showLoginFunc (status, value) {
            this.$refs.myLogin.showLoginFunc(status, value)
        },
        setYunLog (type) {
            const map = {
                'master': "https://log.ssjj.cn/logger/setLog?event=cloudLog",
                'pre': "https://log-uat.ssjj.cn/logger/setLog?event=cloudLog",
            }
            const url = map[process.env.VUE_APP_ENV] ? map[process.env.VUE_APP_ENV] : map.pre

            /**
             *   1: 游戏内（GameInfo组件内）保存桌面按钮
             *   2: 界面右侧（HomeRight组件内）保存桌面按钮
             *   3: 弹窗确认按钮
             *
             */
            let data = {
                type,                                   // 埋点类型
                channel_id: this.channel_id,                          // 渠道
                sub_channel_id: this.sub_channel_id,                   // 子渠道
                device_data: {
                    mac_id: getUniqueBrowserId(),           // mac_id
                },
                attach: gameSession,                    // gameSessionId
            };
            if (this.clientToken) {
                data = {
                    ...data,
                    token: this.clientToken,
                    userChannelAdId: this.channel_ad_id ? this.channel_ad_id : 0, // 用户广告渠道ID
                };
            }
            this.$api.post(url, data).then((res) => {
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        setClientLog (type, code) {
            const map = {
                'master': "https://log.ssjj.cn/logger/setLog?event=clientLog",
                'pre': "https://log-uat.ssjj.cn/logger/setLog?event=clientLog",
            }
            const url = map[process.env.VUE_APP_ENV] ? map[process.env.VUE_APP_ENV] : map.pre

                /**
                 *   8: 打开登录器(8)
                 *   9: 登录账号-检测配置(9)
                 *   12: 云端拉起游戏进程成功，玩家已进入游戏(12)
                 *   25: 点击“注册账号”按钮(25)
                 *   29: 玩家注册成功(29)
                 *   38: 展示实名认证(38)
                 *   39: 实名认证失败(39)
                 *   40: 实名认证成功(40)
                 *   41: 防沉迷认证失败(41)
                 *   51: 云游戏开始排队(51)
                 *   52: 云游戏结束排队(52)
                 *   53: 云游戏排队成功(53)
                 *   54: 云游戏排队失败(54)
                 *   55: 云游戏时长不足(55)
                 *   56: 云游戏时长点击充值(56)
                 *   57: 云游戏时长充值成功(57)
                 *   58: 云游戏异常(58)
                 *   60: 云游戏弹窗更新维护(60)
                 *
                 */
            let data = {
                type,                                   // 埋点类型
                channel_id: this.channel_id,                          // 渠道
                sub_channel_id: this.sub_channel_id,                   // 子渠道
                device_data: {
                    mac_id: getUniqueBrowserId(),           // mac_id
                },
                attach: gameSession,                    // gameSessionId
            };
            if (this.clientToken) {
                data = {
                    ...data,
                    token: this.clientToken,
                    userChannelAdId: this.channel_ad_id ? this.channel_ad_id : 0, // 用户广告渠道ID
                };
            }
            if (type === 58) {
                data.attach = gameSession + ',' + code;
            }
            this.$api.post(url, data).then((res) => {
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        queryAd () {
            this.$api.get('/v1/position', { id: this.is4399 ? '71,72,73,74' : '56,57,66,70' }).then((res) => {
                if (this.is4399) {
                    this.bg = (res && res[71] && res[71][0] && res[71][0].image) || ''; // 视频背景
                    this.desc = (res && res[72] && res[72][0] && res[72][0].image) || ''; //
                    this.lunbo = (res && res[73]) || []; //
                    this.tip = (res && res[74] && res[74][0] && res[74][0].image) || ''; // 启动按钮边上的小图标
                } else {
                    this.bg = (res && res[56] && res[56][0] && res[56][0].image) || ''; // 阿里云游戏主页-背景大图
                    this.desc = (res && res[57] && res[57][0] && res[57][0].image) || ''; // 阿里云游戏主页-描述
                    this.lunbo = (res && res[66]) || []; // 云游戏轮播广告
                    this.tip = (res && res[70] && res[70][0] && res[70][0].image) || ''; // 启动按钮边上的小图标
                }

                console.log(res, '---ad----')
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        async queryUserExit (t) {
            console.log(2)
            await this.$api.get('/v1/cloud/user-exit', {
                t
            }).then((res) => {
                console.log(res, '---sssad----')
                console.log(3)
                this['type_' + t] = 1;
            }).catch((e) => {
                this.$message.error(e.message);
            })
            console.log(4)
        },
        closeRechargeDialog () {
            this.showRecharge = false
        },
        rechargeSuccess () {
            this.setClientLog(57); // 云游戏时长充值成功(57)
            // 充值成功后更新时间
            this.getAccountInfo('recharge');
            this.showRecharge = false
        },
        cancelAnti () {
            this.commonRule = {
                name: '',
                id_card: '',
            }
            this.showAnti = false;
            this.antiReasonShow = false;
            this.clearInfo();
        },

        submitSave () {
            this.checkDialog();
        },
        login (r, type) {
            console.log(r.token, type)
            this.wd_id = r.userData.wd_id;
            this.token = r.token;
            api.setAuthToken(r.token)
            if (r.userData.register) {
                this.setClientLog(29)
            } else {
                this.setClientLog(9)
            }
            this.queryClientInfo(type)
        },
        async checkDialog (cb) {
            let _this = this;
            if (this.supportInstall) {
                this.$confirm(`是否将云游戏添加到桌面，随时畅玩？（您也可以通过快捷键ctrl+D添加页面至收藏夹）`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.setYunLog(3);
                    if (deferredPrompt) {
                        // 展现安装的 prompt
                        deferredPrompt.prompt();
                        // 等待用户对 prompt 进行操作
                        // 如果用户从地址栏或其他浏览器组件安装了PWA，则以下代码将不起作用
                        deferredPrompt.userChoice.then((choiceResult) => {
                            if (choiceResult.outcome === 'accepted') {
                                console.log('点击添加');
                            } else {
                                console.log('取消添加');
                            }
                            deferredPrompt = null;
                        });
                    }
                    cb && cb()
                }).catch((err) => {
                    console.log(err)
                    if (!this.type_1 && err === 'cancel') {
                        this.queryUserExit(1);
                        this.$message({
                            type: 'info',
                            message: '您也可以随时访问官网ssjj.cn，从右上角“云游戏·限时体验”进入'
                        });
                    }
                    cb && cb()
                });
            } else {
                cb && cb()
            }
        },
        startGame () {
            if (this.token) {
                // 启动游戏
                if (!sdkInited) {
                    this.$message.error('游戏初始化尚未完成，请稍后再试');
                } else {
                    let map = {}
                    if (this.is4399) {
                        map = {
                            master: '--DisableGc --PrimaryX 1920 --PrimaryY 1080 -force-d3d11-no-singlethreaded --ChannelId 6 --SubChannelId 24577 -affinity --ABUrl https%3A%2F%2Fcdn.4399ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --updateurl https%3A%2F%2Fmicro.ssjj2.com%2FSSJJ2%2Fboot_config%2Fofficial%2F --CloudGame --quality 4 --ResPath ../AssetBundles',
                            pre: '--DisableGc --PrimaryX 1920 --PrimaryY 1080 -force-d3d11-no-singlethreaded --ChannelId 6 --SubChannelId 24577 -affinity --ABUrl https%3A%2F%2Fcdn.4399ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --updateurl https%3A%2F%2Fmicro-livetest.ssjj2.com%2FSSJJ2%2Fboot_config%2Fyunyouxi_livetest%2F --CloudGame --quality 4 --ResPath ../AssetBundles',
                            develop: '--DisableGc --PrimaryX 1920 --PrimaryY 1080 -force-d3d11-no-singlethreaded --ChannelId 6 --SubChannelId 24577 -affinity --ABUrl https%3A%2F%2Fcdn.4399ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --updateurl https%3A%2F%2Fmicro-livetest.ssjj2.com%2FSSJJ2%2Fboot_config%2Fyunyouxi_livetest%2F --CloudGame --quality 4 --ResPath ../AssetBundles',
                        }
                    } else if (this.isLX) {
                        map = {
                            master: '--DisableGc --PrimaryX 1920 --PrimaryY 1080 -force-d3d11-no-singlethreaded --ChannelId 8 --SubChannelId 32770 -affinity --ABUrl https%3A%2F%2Fstatic-lenovo.ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --updateurl https%3A%2F%2Fmicro.ssjj2.com%2FSSJJ2%2Fboot_config%2Fofficial%2F --CloudGame --quality 4 --ResPath ../AssetBundles',
                            pre: '--DisableGc --PrimaryX 1920 --PrimaryY 1080 -force-d3d11-no-singlethreaded --ChannelId 8 --SubChannelId 32770 -affinity --ABUrl https%3A%2F%2Fstatic-lenovo.ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --updateurl https%3A%2F%2Fmicro-livetest.ssjj2.com%2FSSJJ2%2Fboot_config%2Fyunyouxi_livetest%2F --CloudGame --quality 4 --ResPath ../AssetBundles',
                            develop: '--DisableGc --PrimaryX 1920 --PrimaryY 1080 -force-d3d11-no-singlethreaded --ChannelId 8 --SubChannelId 32770 -affinity --ABUrl https%3A%2F%2Fstatic-lenovo.ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --updateurl https%3A%2F%2Fmicro-livetest.ssjj2.com%2FSSJJ2%2Fboot_config%2Fyunyouxi_livetest%2F --CloudGame --quality 4 --ResPath ../AssetBundles',
                        }
                    } else {
                        map = {
                            master: '--ChannelId 1 --SubChannelId 4228 --DisableGc -force-d3d11-no-singlethreaded -affinity --updateurl https%3A%2F%2Fmicro.ssjj2.com%2FSSJJ2%2Fboot_config%2Fyunyouxi%2F --ABUrl https%3A%2F%2Fstatic2.ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --CloudGame  --PrimaryX 1920 --PrimaryY 1080 --quality 4 --ResPath ../AssetBundles',
                            pre: '--ChannelId 1 --SubChannelId 4228 --DisableGc -force-d3d11-no-singlethreaded -affinity --updateurl https%3A%2F%2Fmicro-livetest.ssjj2.com%2FSSJJ2%2Fboot_config%2Fyunyouxi_livetest%2F --ABUrl https%3A%2F%2Fstatic2.ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --CloudGame  --PrimaryX 1920 --PrimaryY 1080 --quality 4 --ResPath ../AssetBundles',
                            develop: '--ChannelId 1 --SubChannelId 4228 --DisableGc -force-d3d11-no-singlethreaded -affinity --updateurl https%3A%2F%2Fmicro-livetest.ssjj2.com%2FSSJJ2%2Fboot_config%2Fyunyouxi_livetest%2F --ABUrl https%3A%2F%2Fstatic2.ssjj2.com%2FSSJJ2%2Fclient_assetbundle_stability%2F --CloudGame  --PrimaryX 1920 --PrimaryY 1080 --quality 4 --ResPath ../AssetBundles',
                        }
                    }
                    // sdk 启动游戏
                    console.log(process.env.VUE_APP_ENV, '--process.env.VUE_APP_ENV--')
                    if (!map[process.env.VUE_APP_ENV]) {
                        console.error('请检查分支')
                        this.$message.error('请检查分支');
                        return false;
                    }
                    this.loading = true;
                    this.$api.get('/v1/cloud/info').then((res) => {
                        this.wd_id = res.wd_id
                        this.account = res.account // 账号
                        this.anti_level = res.anti_level
                        this.forbid_game = res.forbid_game
                        this.is_test_account = res.is_test_account
                        this.server_status = res.server_status
                        this.clientToken = res.client_token
                        console.log(process.env.NODE_ENV, '---process.env.NODE_ENV----')
                        if (process.env.NODE_ENV === 'production') {
                            if (!res.server_status && !res.is_test_account) {
                                this.loading = false;
                                this.$message.error('游戏尚未开服');
                                return;
                            }
                            if (res.anti_level == 0) {
                                this.loading = false;
                                // this.$message.error('您的账号未进行实名认证，请完成实名认证后再试。');
                                // 未实名
                                this.$myConfirm({
                                    text: '您的账号未进行实名认证，请完成实名认证后再试。',
                                    title: '未实名认证',
                                    confirmShow: true,
                                    cancelShow: true,
                                    showClose: false,
                                    confirmText: '前往认证',
                                }).then(() => {
                                    this.setClientLog(38);  // 展示实名认证
                                    if (this.is4399) {
                                        window.open(this.real_name_url);
                                    } else {
                                        this.showAnti = true
                                    }
                                }).catch((e) => {
                                    console.log(e)
                                    this.clearInfo();
                                    // 取消用户登录状态
                                })
                                return;
                            }
                            if (res.anti_level == 2 && res.forbid_game == 1) {
                                this.loading = false;
                                this.setClientLog(41);  // 防沉迷认证失败(41)
                                // 2实名未成年且未成年禁止进入游戏
                                this.$myConfirm({
                                    text: '您未满18岁，我们仅会在周五、周六、周日和法定节假日每日20:00~21:00提供一小时的游戏服务。',
                                    title: '防沉迷提醒',
                                    confirmShow: true,
                                    cancelShow: false,
                                    showClose: false,
                                    confirmText: '关闭',
                                }).then(() => {
                                }).catch((e) => {
                                    console.log(e)
                                    this.clearInfo();
                                })
                                return;
                            }
                        }
                        console.log(this.user_level, '--------this.user_level----')
                        this.sdkPrepare({
                            userId: this.wd_id,
                            userLevel: this.user_level,
                            userToken: this.clientToken,
                            mixGameId: this.mixGameId,
                            gameCmdParam: map[process.env.VUE_APP_ENV],
                            isVertical: false,
                        })
                    }).catch((e) => {
                        this.loading = false;
                        this.$message.error(e.message);
                    })
                }
                console.log('开始游戏')
            } else {
                this.showLoginFunc(true, 'login')
            }
        },
        clearInfo () {
            // 调用时机为： 1、用户登录账号取消实名认证/未成年人禁止进入游戏时    2、结束游戏成功时
            this.token = ''
            this.showRecharge = false
            this.showAnti = false
            this.antiReasonShow = false
            this.wd_id = 0
            api.setAuthToken('')
            this.setProcess(1);
            // 关闭账户信息定时器
            clearInterval(accountInterval)
            accountInterval = null;
            clearInterval(timeLimit)
            timeLimit = null;
            this.forbid_game = ''
            this.is_test_account = ''
        },
        exitGame () {
            if (!this.type_2) {
                this.queryUserExit(2);
                this.checkDialog();
            }
            this.gameStop();
        },
        copy () {
            this.$copyText(gameSession).then((e) => {
                this.$message.success('复制成功');
                console.log(e)
            }, function (e) {
                this.$message.error('复制失败');
                console.log(e)
            });
        },
        buyTime () {
            this.setClientLog(56); // 云游戏时长点击充值(56)
            this.showRecharge = true;
        },
        cancelQueue () {
            this.gameStop();
        },
        signOut () {
            if (!this.type_0 && this.supportInstall) {
                this.checkDialog()
                this.queryUserExit(0);
            }
            this.$api.get('/api/user/logout').then((res) => {
                // 退出登录停止游戏
                this.gameStop();
                this.clearInfo();
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        queryClientInfo (type) {
            // 通过接口获取客户端信息（含client token）
            this.$api.get('/v1/cloud/info').then(async (res) => {
                console.log(res)
                if (res.channel_id == 8) {
                    // 由于联想使用官方登录，因此不能仅仅靠from来判断，只能通过用户信息来判断
                    this.isLX = true
                }
                this.share_link = res.share_link
                this.wd_id = res.wd_id
                this.account = res.account // 账号
                this.clientToken = res.client_token
                this.anti_level = res.anti_level
                this.channel_ad_id = res.channel_ad_id
                // this.sub_channel_id = res.sub_channel_id
                this.forbid_game = res.forbid_game
                this.is_test_account = res.is_test_account
                this.server_status = res.server_status
                this.real_name_url = res.real_name_url
                this.third = res.third || []
                this.type_0 = res.type_0 || 0;
                this.type_1 = res.type_1 || 0;
                this.type_2 = res.type_2 || 0;
                this.setShowLogin(false)

                // 先获取到apiToken进行初始化
                await this.queryApiToken()
                interval = setInterval(this.queryApiToken, 10 * 60 * 1000)
                console.log(sdkIniting, '----', sdkInited)
                if (!sdkIniting && !sdkInited) {
                    this.sdkInit()
                }

                console.log(process.env.NODE_ENV, '==process.env.NODE_ENV==')
                if (process.env.NODE_ENV === 'development') {
                    this.getAccountInfo(true)
                } else {
                    if (!res.server_status && !res.is_test_account) {
                        this.setClientLog(60); // 云游戏弹窗更新维护(60)
                        // 游戏尚未开服
                        this.$myConfirm({
                            text: '游戏尚未开服。',
                            title: '提示',
                            confirmShow: true,
                            cancelShow: false,
                            showClose: false,
                            confirmText: '确定',
                        })
                    } else if (res.anti_level == 0) {
                        // 未实名
                        this.$myConfirm({
                            text: '您的账号未进行实名认证，请完成实名认证后再试。',
                            title: '未实名认证',
                            confirmShow: true,
                            cancelShow: true,
                            showClose: false,
                            confirmText: '前往认证',
                        }).then(() => {
                            this.setClientLog(38);  // 展示实名认证
                            if (this.is4399) {
                                window.open(this.real_name_url);
                            } else {
                                this.showAnti = true
                            }
                        }).catch((e) => {
                            console.log(e)
                            this.clearInfo();
                            // 取消用户登录状态
                        })
                    } else if (res.anti_level == 2 && res.forbid_game == 1) {
                        // 2实名未成年且未成年禁止进入游戏
                        this.$myConfirm({
                            text: '您未满18岁，我们仅会在周五、周六、周日和法定节假日每日20:00~21:00提供一小时的游戏服务。',
                            title: '防沉迷提醒',
                            confirmShow: true,
                            cancelShow: false,
                            showClose: false,
                            confirmText: '关闭',
                        }).then(() => {
                            this.getAccountInfo(true)
                        }).catch((e) => {
                            console.log(e)
                            this.clearInfo();
                        })
                    } else {
                        this.getAccountInfo(true)
                    }
                }
            }).catch((e) => {
                this.setShowLogin(false)
                this.$message.error(e.message);
                this.token = '';
                api.setAuthToken('')
                this.wd_id = 0;
            })
        },
        async queryApiToken () {
            // 通过接口获取SDK初始化信息，每隔10分钟进行获取并刷新配置
            await this.$api.get('/v1/cloud/token').then((res) => {
                // todo 获取到apiToken之后，init初始化sdk
                this.appKey = res.accessKey
                this.appSecret = res.accessSecret
                this.apiToken = res.token
                acgCoreManager.refreshConfig({
                    appKey: res.accessKey,
                    appSecret: res.accessSecret,
                    apiToken: res.token
                })
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        emitGetAccount () {
            this.getAccountInfo('recharge')
        },
        // 获取账户信息
        getAccountInfo (notInterval) {
            this.$api.get('/v1/cloud/account-info', {
                interval: !notInterval
            }).then((res) => {
                console.log(res, ';----')
                this.setMissionCompleteStatus(res.have_rewards);
                this.expire_time = res.expire_time // 月卡到期时间（时间戳，单位秒）
                this.ttl = res.ttl // 月卡剩余时长（为0代表月卡已失效）
                this.left_time = res.left_time // 剩余标准时长（单位：秒）
                this.left_exp_time = res.left_exp_time // 剩余体验时长（单位：秒）
                if (res.user_level) {
                    this.user_level = res.user_level // 用户级别
                }
                let str = ''
                if (res.first_login) {
                    str += `获得新人时长${secondsToTime(res.first_login_reward, 'time')};`
                }
                if (res.daily_login) {
                    str += `每日登录奖励${secondsToTime(res.daily_login_reward, 'time')};`
                }
                if (this.left_exp_time === 1140 * 60) {
                    str += '免费累积时长已达1140分钟上限'
                }
                if (str) {
                    this.$message.success(str);
                }
                let timeNumber = parseInt(res.ttl + res.left_time + res.left_exp_time - res.game_time);
                this.limitTime = timeNumber > 0 ? timeNumber : 0;
                console.log(secondsToTime(this.limitTime, 'day'), '----this.limitTime---')

                if (notInterval === 'recharge') {
                   // 来自充值成功的回调
                   //  this.$message('充值成功')
                    if (this.process === 2 && this.limitTime > 360) {
                        this.setProcess(1);
                    }
                } else if (notInterval) {
                    if (this.limitTime <= 360) {
                        // todo 提示去充值 rechargeNow
                        this.setClientLog(55);  // 云游戏时长不足(55)
                        this.setProcess(2)
                    } else {
                        this.setProcess(1)
                        // this.startGame()
                    }
                } else {
                    // 来自定时器
                    if (this.limitTime <= 360) {
                        this.setClientLog(55);  // 云游戏时长不足(55)
                        this.$message('当前余额所剩不多，请及时充值')
                    }
                    // 先清除之前的倒计时定时器
                    clearInterval(timeLimit)
                    timeLimit = null;
                    // 更新完时间后重新倒计时
                    this.startTimeLimit()
                }
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        // 验证/提交实名信息
        sureAnti () {
            let r = true
            if (!this.commonRule.name.trim().length) {
                r = false
            }
            if (!isIdCard(this.commonRule.id_card)) {
                r = false
            }
            if (!r) {
                this.$message.error('数据有误，请确认后输入');
                return false
            }

            timer = Loading.service({ fullscreen: true })
            this.$api.post('/v1/cloud/real-name', {
                ...this.commonRule
            }).then((res) => {
                console.log(res)
                setTimeout(this.queryAntiStatus, 3000)
            }).catch((e) => {
                timer.close();
                this.$message.error(e.message);
            })
        },
        queryAntiStatus () {
            // 获取实名认证状态
            this.$api.get('/v1/cloud/check-real-name').then((res) => {
                console.log(res)
                timer.close()
                if (res.anti_level == 0) {
                    this.antiReasonShow = true;
                    this.setClientLog(39);  // 实名认证失败(39)
                } else if (res.anti_level == 2 && this.forbid_game == 1) {
                    this.setClientLog(40);  // 防沉迷认证失败，但是属于实名认证成功(40)
                    this.showAnti = false;
                    // 2实名未成年且未成年禁止进入游戏
                    this.$myConfirm({
                        text: '您未满18岁，我们仅会在周五、周六、周日和法定节假日每日20:00~21:00提供一小时的游戏服务。',
                        title: '防沉迷提醒',
                        confirmShow: true,
                        cancelShow: false,
                        confirmText: '关闭',
                    }).then(() => {
                    }).catch((e) => {
                    })
                } else {
                    this.setClientLog(40);  // 实名认证成功(40)
                    this.showAnti = false;
                    this.getAccountInfo(true)
                }
                // 更新实名结果
                this.anti_level = res.anti_level
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        gameStop () {
            acgCoreManager.stop({
                mixGameId: this.mixGameId,
                userId: this.wd_id,
                userToken: this.token
            });
            this.loading = true;
        },
        // sdk方法
        sdkListenerHandler (handlerId, type, code, msg, level) {
            const _this = this;
            if (type !== '280') {
                // console.log(`${level}: ${code}: %o`, msg);
                if (!gameSession) {
                    gameSession = acgInteractManager.getGameSession()
                    console.log(gameSession, '----gameSession----')
                }
                // $copyText.innerText = gameSession
            } else {
                if (type == '280' && code == '2809000') {
                    // console.log(`${level}: ${code}: %o`, msg.netWorkDelay)
                    console.log(msg)
                    _this.netWorkDelay = msg.netWorkDelay;
                    _this.fps = msg.fps;
                    _this.bitrate = msg.bitrate;
                    _this.packetLossRate = msg.packetLossRate;
                }
                if (type == '10') {
                // （SDK初始化过程相关、mtop sdk的相关抛错）
                }
                if (type == '20') {
                // 正常启动相关
                }
                if (type == '30') {
                // SDK内核加载相关
                }
                if (type == '40') {
                // （抛出数据相关，⼀般为⼀些json数据）
                }
                if (type == '50') {
                // 服务端调度接⼝抛错
                }
            }
            switch (code) {
                case '101032':
                    // 启动时抛出，当前token已经过期，为异常行为，会中断启动
                    _this.queryApiToken();
                    // showMessage('当前token已经过期')
                    break
                case '101033':
                    // 游戏中抛出，当前token已经过期，用户可以继续玩，但心跳会丢失
                    _this.queryApiToken();
                    // showMessage('当前token已经过期')
                    break
                case '101034':
                    // 游戏中抛出，当前token即将过期，用户可以继续玩
                    _this.queryApiToken();
                    // showMessage('当前token即将过期')
                    // 接入方需调用open api获取最新的临时token，再通过refreshconfig接口更新appKey、appSecret、apiToken
                    // action1: 调用open api获取新的token等信息
                    // action2: acgCoreManager.refreshConfig({appKey, appSecret, apiToken});
                    break
                case '103010':
                    console.log('游戏初始化成功')
                    sdkInited = true
                    break
                case '2702020':
                    msgInput && msgInput.setFocus(true);
                    break;
                case '2702021':
                    msgInput && msgInput.setFocus(false);
                    break;
                case '401020':
                    // 排队回调
                    console.log(msg)
                    _this.loading = false;
                    if (msg.slotstate === 1) {
                        _this.setProcess(4)
                        _this.holdTime = msg.timeToWait;
                        _this.person = msg.usersBefore;
                        // showMessage('排队中，前面还有' + msg.usersBefore + '人')
                    } else if (msg.slotstate === 2) {
                        console.log('排队完成')
                        _this.startGame();
                    }
                    break
                case '201010':
                    _this.setProcess(3)
                    // perpare结束之后直接开始游戏
                    acgCoreManager.start()
                    break
                case '201020':
                    break
                case '2701040':
                    // 画面准备就绪
                    _this.clientRuning = true;
                    _this.loading = false;
                    accountInterval = setInterval(this.getAccountInfo, 5 * 60 * 1000)
                    _this.startTimeLimit();
                    _this.setClientLog(12)
                    console.log('acgCoreManager.start结束，画面准备就绪，游戏启动成功')
                    break
                case '2703020':
                    // 软总线授权，默认授权通过，业务方可根据情况决定是否授权
                    acgInteractManager.notifyActionResult(msg)
                    break
                case '2709010':
                    console.log('游戏结束成功')
                    // 关闭倒计时定时器
                    clearInterval(timeLimit)
                    gameSession = '';
                    timeLimit = null;
                    _this.clientRuning = false;
                    _this.setProcess(1)
                    _this.loading = false;

                    _this.setProcess(1);
                    // 关闭账户信息定时器
                    clearInterval(accountInterval)
                    accountInterval = null;
                    clearInterval(timeLimit)
                    timeLimit = null;
                    if (_this.token) {
                        _this.getAccountInfo(true)
                    }
                    break
                case '2201010':
                case '2201013':
                    // showMessage('进入重连流程')
                    break
                case '2301010':
                    // showMessage('游戏重连成功')
                    break
                case '403010':
                    console.log(_this.channel_ad_id, '发送token信息', _this.toUint8Arr(_this.clientToken))
                    // acgInteractManager.sendDataToGame(this.toUint8Arr(this.clientToken))
                    acgInteractManager.sendDataToGame(this.toUint8Arr(
                        JSON.stringify({
                            token: _this.clientToken,
                            adid: _this.channel_ad_id
                        }
                    )));
                    // showMessage('游戏重连成功')
                    break
                case '701098':
                    // showMessage('游戏重连成功')
                    break
                case '701099':
                    // showMessage('游戏重连成功')
                    break
                default:
                    break
            }
            if (level === 'onError') {
                console.error(`${msg}[${code}]`)
                _this.setClientLog(58, code);  // 云游戏异常(58)
                _this.gameStop();

                if (code == 501020) {
                    _this.$message.error('当前服务器火爆中，可收藏页面，稍后再试~');
                } else if (code == 503080) {
                    _this.$message.error(msg);
                    // 排队-用户准入失败，可能是过程中user_level发生变更，因此需要更新下user_level
                    _this.getAccountInfo(true)
                } else {
                    _this.$message.error(msg);
                }
                // showMessage(`${msg}[${code}]`)
            }
        },
        toUint8Arr (str) {
            const buffer = []
            for (let i of str) {
                const _code = i.charCodeAt(0)
                if (_code < 0x80) {
                    buffer.push(_code)
                } else if (_code < 0x800) {
                    buffer.push(0xc0 + (_code >> 6))
                    buffer.push(0x80 + (_code & 0x3f))
                } else if (_code < 0x10000) {
                    buffer.push(0xe0 + (_code >> 12))
                    buffer.push(0x80 + (_code >> 6 & 0x3f))
                    buffer.push(0x80 + (_code & 0x3f))
                }
            }
            return Uint8Array.from(buffer)
        },
        startTimeLimit () {
            // 开始倒计时
            timeLimit = setInterval(() => {
                this.limitTime -= 60;
            }, 60000)
        },
        sdkInit () {
            // 仅需要执行一次init流程
            if (sdkIniting || sdkInited) return
            sdkIniting = true
            // 添加事件监听及调用init接口
            cgSDK.addListener(this.sdkListenerHandler)
            console.log(this.apiToken, '---this.apiToken---')
            acgCoreManager.init({
                apiToken: this.apiToken,
                appKey: this.appKey,
                appSecret: this.appSecret,
                appVersion: '1',
                speedTest: true,
            })
            // 监听resize事件
            window.addEventListener('resize', () => {
                setTimeout(() => {
                    const {
                        width,
                        height,
                        rotate
                    } = resizeStage($container, false)
                    acgInteractManager.setSize(width, height, rotate)
                }, 200)
            }, false)
        },
        sdkPrepare (data) {
           const a = window.getComputedStyle(document.querySelector('body'));
            // 在单页多次起游戏的情况下，请确保上个游戏session已执行了stop流程。
            const {
                userId,
                userToken,
                userLevel,
                mixGameId,
                isVertical,
                gameCmdParam,
            } = data
            // preapre参数
            const prepareParams = {
                userId,
                userToken,
                userLevel,
                width: a.width,
                height: a.height,
                margin: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                containerId: '#cgameLayer',
                mixGameId,
                gameCmdParam,
                isVertical,
                // 根据游戏的情况以及使用场景设置合适的输入模式
                // 此demo的配置为手游的输入配置
                hidConfig: {
                    1: true, // 禁用虚拟手柄
                    2: false, // 禁用touch输入
                    3: false, // 启用实体手柄
                    4: true, // 启用鼠标输入
                    5: true, // 启用键盘输入
                },
            }
            const resizeObj = resizeStage($container, isVertical)
            console.log(prepareParams, '---prepareParams----')
            acgCoreManager.prepare(Object.assign({}, prepareParams, resizeObj))
        },
    },
}
</script>
<style scoped lang="less">
#cgameLayer {
    z-index: 50;
}
.anti-main {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 10px;
    .refuse-result {
        font-size: 14px;
        color: red;
    }
}
.anti-input-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.anti-footer {
    cursor: pointer;
    color: #fff;
    width: 100%;
    margin: 0 auto;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    > div {
        background: #eb5541;
        padding: 10px 20px;
        border-radius: 7px;
    }
    .cancel-btn {
        background: #d5d5d5;
        margin-right: 10px;
        color: #000;
    }
}

.home-info {
    color: #7289A6;
    z-index: 5;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .home-left {
        flex: 1;
        position: relative;
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        img {
            width: 716px;
            height: 166px;
            margin-bottom: 82px;
        }
    }
    .home-right {
        width: 550px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url("../assets/images/home/home-right-bg.png");
        box-sizing: border-box;
    }

}
.game-box {
    display: flex;
    justify-content: space-between;
    background-image: url("../assets/images/gameInfo/info.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 377px;
    height: 31px;
    align-items: center;
    padding: 0 20px;
    color: #B0CAEB;
    font-size: 12px;
}
.game-info-item {
    display: flex;
}
.game-value {
    color: #53DA56;
}
.color-red {
    color: #da5353;
}

.top-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 150;
}

.main-content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 100vh;
    overflow: hidden;
    text-align: center;
    background-color: #000;
    background-size: 100%;
    background-repeat: no-repeat;

    .home-main {
        width: 100%;
        z-index: 2;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .bg {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
    }
}
</style>
